const LearnItem = function (content) {
  this.id = content.id
  this.title = content.title
  this.thumbnail = content.thumbnail
  this.description = content.description
  this.authorName = content.authorName
  this.authorPosition = content.authorPosition
  this.authorThumbnail = content.authorThumbnail
  this.authorProfile = content.authorProfile
  this.authorUrl = content.authorUrl
  this.markdownPath = content.markdownPath
}
export default [
  new LearnItem({
    'id': 'what-is-businessplan',
    'title': '【超入門】事業計画書とは？必要な理由と説得力のある書き方のポイント',
    'thumbnail': '/learn/images/what-is-businessplan.png',
    'description': 'これから事業をスタートさせたいと考えている方へ、事業計画書とは何なのか、どうして必要なのかについてわかりやすく解説します。読む相手を説得させるための書き方のポイントもご紹介しますので、実際に作成されるときに参考にしてください。',
    'authorName': '3kyaku',
    'authorPosition': '',
    'authorThumbnail': '/common/images/3kyaku-icon-square.png',
    'authorProfile': '',
    'authorUrl': 'https://3kyaku.jp',
    'markdownPath': '/learn/markdown/1_what-is-businessplan.md'
  }),
  new LearnItem({
    'id': 'how-to-raise-funds',
    'title': '【初めての】起業資金の調達方法まとめ「４つの調達先と申請」',
    'thumbnail': '/learn/images/how-to-raise-funds.png',
    'description': '開業・起業（個人事業主を含む）の際の資金の調達方法に何があるかをまとめました。調達先ごとの審査における難易度、向き不向き（会社設立・個人事業主）、メリット・デメリット、申請方法などわかりやすく解説します。',
    'authorName': '小林　守',
    'authorPosition': '経営コンサルタント',
    'authorThumbnail': '/learn/images/thumb_mamoru_kocayashi.jpg',
    'authorProfile': '経営コンサルタント。早稲田大学卒。都市銀行に１０年間勤務したのち、経営コンサルタントの道に入り、株式会社近代マネジメントを設立、代表取締役に就任。経済産業省登録 中小企業診断士。専門は経営診断、経営戦略立案、マーケティング・マネジメント・コンサルティング、営業店再開発、新店舗開設、産業心理学・経営組織論。これまで「ゼロからわかる新規融資・成長支援」「あたりまえだけどなかなかできない商談のルール」「強い得意先集団のつくり方」など専門書・ビジネス書を28冊執筆し、11誌紙で連載を担当。能力開発・教育訓練の分野では、経営者・管理者・営業担当者・新入社員などの研修講師を歴任。執筆、講演、講座など実践中。',
    'authorUrl': 'http://kindai-management.jimdo.com/',
    'markdownPath': '/learn/markdown/2_how-to-raise-funds.md'
  }),
  new LearnItem({
    'id': 'preparation-for-writing',
    'title': '【超入門】事業計画書の書き方～記載項目と書くための準備',
    'thumbnail': '/learn/images/preparation-for-writing.png',
    'description': '事業計画書は、資金を調達する際や、事業の進捗管理、準備や経営の状況を把握するときに必要な書類です。初めて作成する方にもわかりやすく、記載すべき項目や書くために準備すべきことについて解説します。書くことを頭に入れしっかりと準備をすることで、わかりやすい事業計画書を作成しましょう。',
    'authorName': '小林　守',
    'authorPosition': '経営コンサルタント',
    'authorThumbnail': '/learn/images/thumb_mamoru_kocayashi.jpg',
    'authorProfile': '経営コンサルタント。早稲田大学卒。都市銀行に１０年間勤務したのち、経営コンサルタントの道に入り、株式会社近代マネジメントを設立、代表取締役に就任。経済産業省登録 中小企業診断士。専門は経営診断、経営戦略立案、マーケティング・マネジメント・コンサルティング、営業店再開発、新店舗開設、産業心理学・経営組織論。これまで「ゼロからわかる新規融資・成長支援」「あたりまえだけどなかなかできない商談のルール」「強い得意先集団のつくり方」など専門書・ビジネス書を28冊執筆し、11誌紙で連載を担当。能力開発・教育訓練の分野では、経営者・管理者・営業担当者・新入社員などの研修講師を歴任。執筆、講演、講座など実践中。',
    'authorUrl': 'http://kindai-management.jimdo.com/',
    'markdownPath': '/learn/markdown/3_preparation-for-writing.md'
  }),
  new LearnItem({
    'id': 'entry-example',
    'title': '資金調達先別の必要書類と記入例',
    'thumbnail': '/learn/images/entry-example.png',
    'description': '事業の資金調達を成功させるためには「書類の質」が大切です。ここでは、資金調達方法のうち、融資と補助金・助成金について審査をパスするための書き方のポイントを、わかりやすく解説していきます。',
    'authorName': '小林　守',
    'authorPosition': '経営コンサルタント',
    'authorThumbnail': '/learn/images/thumb_mamoru_kocayashi.jpg',
    'authorProfile': '経営コンサルタント。早稲田大学卒。都市銀行に１０年間勤務したのち、経営コンサルタントの道に入り、株式会社近代マネジメントを設立、代表取締役に就任。経済産業省登録 中小企業診断士。専門は経営診断、経営戦略立案、マーケティング・マネジメント・コンサルティング、営業店再開発、新店舗開設、産業心理学・経営組織論。これまで「ゼロからわかる新規融資・成長支援」「あたりまえだけどなかなかできない商談のルール」「強い得意先集団のつくり方」など専門書・ビジネス書を28冊執筆し、11誌紙で連載を担当。能力開発・教育訓練の分野では、経営者・管理者・営業担当者・新入社員などの研修講師を歴任。執筆、講演、講座など実践中。',
    'authorUrl': 'http://kindai-management.jimdo.com/',
    'markdownPath': '/learn/markdown/4_entry-example.md'
  }),
  new LearnItem({
    'id': 'knowledge',
    'title': '起業するには？知っておきたい5つの手順と基礎知識',
    'author': '小林 守',
    'thumbnail': '/learn/images/knowledge.png',
    'description': '世の中の役に立ちたい、自分のアイデアを試したい、独立してやってみたいという方に、今日から始められる、起業するための基本的な手順と基礎知識をお伝えします。何から手を付けたらたらいいのか悩んでいる方も、具体的な流れや知識を学んで起業へ向けて一歩踏み出しませんか？',
    'authorName': '小林　守',
    'authorPosition': '経営コンサルタント',
    'authorThumbnail': '/learn/images/thumb_mamoru_kocayashi.jpg',
    'authorProfile': '経営コンサルタント。早稲田大学卒。都市銀行に１０年間勤務したのち、経営コンサルタントの道に入り、株式会社近代マネジメントを設立、代表取締役に就任。経済産業省登録 中小企業診断士。専門は経営診断、経営戦略立案、マーケティング・マネジメント・コンサルティング、営業店再開発、新店舗開設、産業心理学・経営組織論。これまで「ゼロからわかる新規融資・成長支援」「あたりまえだけどなかなかできない商談のルール」「強い得意先集団のつくり方」など専門書・ビジネス書を28冊執筆し、11誌紙で連載を担当。能力開発・教育訓練の分野では、経営者・管理者・営業担当者・新入社員などの研修講師を歴任。執筆、講演、講座など実践中。',
    'authorUrl': 'http://kindai-management.jimdo.com/',
    'markdownPath': '/learn/markdown/5_knowledge.md'
  }),
  new LearnItem({
    'id': 'bibliography',
    'title': '【初めての起業】会社設立・登記に役立つ基礎知識まとめ',
    'thumbnail': '/learn/images/bibliography.png',
    'description': '法人化を考え出したあなたに、会社を設立する際に必要な手続き、登記、かかる費用、そして注意すべき点などを分かりやすくまとめました。株式会社の設立を中心に、手続きや登記の基礎知識をみていきます。',
    'authorName': '3kyaku',
    'authorPosition': '',
    'authorThumbnail': '/common/images/3kyaku-icon-square.png',
    'authorProfile': '',
    'authorUrl': 'https://3kyaku.jp',
    'markdownPath': '/learn/markdown/6_bibliography.md'
  }),
  new LearnItem({
    'id': 'one-point',
    'title': '資金調達成功のためのワンポイントアドバイス',
    'thumbnail': '/learn/images/one-point.png',
    'description': '起業時の資金調達を成功させるには、調達先を上手に選ぶことと、そこでの審査がスムーズに通ることが大切です。調達先の特徴を把握し、審査で重要視されるポイントを知っておきましょう。今回は、経営コンサルタントの視点から見た重要なポイントをアドバイスします。',
    'authorName': '小林　守',
    'authorPosition': '経営コンサルタント',
    'authorThumbnail': '/learn/images/thumb_mamoru_kocayashi.jpg',
    'authorProfile': '経営コンサルタント。早稲田大学卒。都市銀行に１０年間勤務したのち、経営コンサルタントの道に入り、株式会社近代マネジメントを設立、代表取締役に就任。経済産業省登録 中小企業診断士。専門は経営診断、経営戦略立案、マーケティング・マネジメント・コンサルティング、営業店再開発、新店舗開設、産業心理学・経営組織論。これまで「ゼロからわかる新規融資・成長支援」「あたりまえだけどなかなかできない商談のルール」「強い得意先集団のつくり方」など専門書・ビジネス書を28冊執筆し、11誌紙で連載を担当。能力開発・教育訓練の分野では、経営者・管理者・営業担当者・新入社員などの研修講師を歴任。執筆、講演、講座など実践中。',
    'authorUrl': 'http://kindai-management.jimdo.com/',
    'markdownPath': '/learn/markdown/7_one-point.md'
  }),
  new LearnItem({
    'id': 'devise',
    'title': '【起業のリスク一覧】トラブルを避けるための対処法まとめ',
    'thumbnail': '/learn/images/devise.png',
    'description': 'リスクを気にして起業をためらっている方も多いのではないでしょうか？起業にかかわるリスクと対処法をわかりやすく解説します。起こりうるリスクと対処法をしっかりと把握して、トラブルを回避しましょう。',
    'authorName': '小林　守',
    'authorPosition': '経営コンサルタント',
    'authorThumbnail': '/learn/images/thumb_mamoru_kocayashi.jpg',
    'authorProfile': '経営コンサルタント。早稲田大学卒。都市銀行に１０年間勤務したのち、経営コンサルタントの道に入り、株式会社近代マネジメントを設立、代表取締役に就任。経済産業省登録 中小企業診断士。専門は経営診断、経営戦略立案、マーケティング・マネジメント・コンサルティング、営業店再開発、新店舗開設、産業心理学・経営組織論。これまで「ゼロからわかる新規融資・成長支援」「あたりまえだけどなかなかできない商談のルール」「強い得意先集団のつくり方」など専門書・ビジネス書を28冊執筆し、11誌紙で連載を担当。能力開発・教育訓練の分野では、経営者・管理者・営業担当者・新入社員などの研修講師を歴任。執筆、講演、講座など実践中。',
    'authorUrl': 'http://kindai-management.jimdo.com/',
    'markdownPath': '/learn/markdown/8_devise.md'
  })
]
